/* eslint-disable max-lines */
import { Modal, Form, Row, Col, Input, Typography, Space,Alert } from "antd"
import {
  DateField,
  FieldLabel,
  SelectField,
  MultipleTextField
} from "../../../shared"
import { getSelectValue, toFileList } from "../../../../helpers/"
import {
  measurementPeriodicityTypes,
  verificationTypes
} from "../../../../helpers/selectOptions/implementer/submission"
import { UploadButtonForm } from "../../../shared"
import { useContext, useEffect, useState } from "react"
import moment from "moment"
import PropTypes from "prop-types"
import { v4 as uuid } from "uuid"
import { CommentsContext } from "../../../../contexts/admin/submissions/review/comments/context"

IndicatorModal.propTypes = {
  indicatorType: PropTypes.string,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  limitDates: PropTypes.array,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  hiddenComments: PropTypes.any,
  review: PropTypes.bool,
  edit: PropTypes.object
}

export function IndicatorModal ({
  indicatorType,
  onSave,
  onCancel,
  limitDates,
  readOnly,
  edit,
  hiddenComments,
  review,
  rol,
  ...props
}) {
  const [form] = Form.useForm()
  const { updateEntities } = useContext(CommentsContext)
  const [isBlocking, setIsBlocking] = useState(false)


  useEffect(() => {
    if (edit) {
      setIsBlocking(edit.isBlocking && rol);
      form.setFieldsValue(edit)
      edit?.id && updateEntities([{ entity: "indicator", id: edit.id }])
    }
  }, [edit])

  const onOk = async () => {
    try {
      let values = await form.getFieldsValue()

      if (typeof edit?.index !== "undefined") {
        edit.products = null
        edit.meansOfVerification = null
        values = {
          ...edit,
          ...values
        }
      }

      onSave({ ...values, tempId: uuid() })
      form.resetFields()
    }
    catch (e) {
      console.error(e)
    }
  }

  const onCancelModal = () => {
    form.resetFields()
    onCancel && onCancel()
  }

  const onDoneFile = async files => {
    const documents = files?.map(el => {
      return { name: el.name, url: el.url }
    })
    try {
      form.setFieldsValue({ metodologyDocuments: documents })
    }
    catch (e) {
      console.error(e)
    }
  }

  const onRemoveFile = async ({ url }) => {
    const oldDocuments = form.getFieldValue("metodologyDocuments")
    const documents = oldDocuments?.filter(document => document.url !== url)
    form.setFieldsValue({ metodologyDocuments: documents })
  }

  return (
    <Modal
      title={`${edit ? "Editar" : "Agregar"} indicador`}
      onOk={onOk}
      onCancel={onCancelModal}
      okButtonProps={{ disabled: review ||  isBlocking}}
      destroyOnClose={true}
      width={800}
      okText={`${edit ? "Guardar" : "Agregar"}`}
      cancelText={(review ||  isBlocking) ? "Cerrar" : "Cancelar"}
      maskClosable={false}
      {...props}>
      <Form
        form={form}
        name="indicator-form"
        layout="vertical">
        <Row gutter={[10, 8]} justify="start">
          <Col span={24}>
            <Form.Item
              name="title"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "title",
                  section: indicatorType,
                  entityId: edit?.id,
                  entity: "indicator"
                }}>
                  Nombre del indicador
                </FieldLabel>
              }>
              <Input.TextArea
                autoSize
                disabled={ isBlocking}
                id="title"
                type="text" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="description"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "description",
                  section: indicatorType,
                  entityId: edit?.id,
                  entity: "indicator"
                }}>
                  Indicador
                </FieldLabel>
              }>
              <Input.TextArea
                autoSize
                disabled={ isBlocking}
                id="description"
                type="text" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="methodology"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "methodology",
                  section: indicatorType,
                  entityId: edit?.id,
                  entity: "indicator"
                }}>
                  Metodología
                </FieldLabel>
              }>
              <Input.TextArea
                autoSize
                disabled={ isBlocking}
                id="methodology"
                type="text" />
            </Form.Item>
          </Col>
          <Col span={24} style={{ marginBottom: "10px" }}>
            <Form.Item
              name="metodologyDocuments"
              label={
                <Space direction="vertical">
                  <Typography.Text>
                    Documentos de metodología
                  </Typography.Text>
                  <Typography.Text style={{ color: "#949494" }}>
                    Adjunta el instrumento de evaluación y la nota metodológica y/o{" "}
                    cualquier documento que sea necesario para entender la metodología.
                  </Typography.Text>
                </Space>
              }
              style={{ display: "inline" }}>
              <UploadButtonForm
                maxFile={5}
                disabled={ isBlocking}
                onRemoveFile={onRemoveFile}
                onChange={onDoneFile}
                fileList={toFileList(edit?.metodologyDocuments || [])}>
                Adjuntar Documentos
              </UploadButtonForm>
            </Form.Item>
            <br></br>
          </Col>
          <Col span={12}>
            <Form.Item
              name="formula"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "formula",
                  section: indicatorType,
                  entityId: edit?.id,
                  entity: "indicator"
                }}>
                  Fórmula
                </FieldLabel>
              }>
              <Input.TextArea
                autoSize
                disabled={ isBlocking}
                id="formula"
                type="text" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="meansOfVerification"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "meansOfVerification",
                  section: indicatorType,
                  entityId: edit?.id,
                  entity: "indicator"
                }}>
                  Medio de verificación
                </FieldLabel>
              }
              getValueFromEvent={getSelectValue}>
              <SelectField
                id="meansOfVerification"
                disabled={ isBlocking}
                filterOption={(value, option) => option?.children?.toLowerCase().includes(value?.toLowerCase())}
                mode="multiple"
                showSearch
                options={verificationTypes} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="baseline"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "baseline",
                  section: indicatorType,
                  entityId: edit?.id,
                  entity: "indicator"
                }}>
                  Línea base
                </FieldLabel>
              }>
              <Input.TextArea
                autoSize
                disabled={ isBlocking}
                id="baseline"
                type="text" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="goal"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "goal",
                  section: indicatorType,
                  entityId: edit?.id,
                  entity: "indicator"
                }}>
                  Meta
                </FieldLabel>
              }>
              <Input
                autoSize
                disabled={ isBlocking}
                id="goal"
                type="number" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="startDate"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "startDate",
                  section: indicatorType,
                  entityId: edit?.id,
                  entity: "indicator"
                }}>
                  Fecha de inicio *
                </FieldLabel>
              }
              getValueFromEvent={getSelectValue}>
              <DateField
                id="startDate"
                disabled={ isBlocking}
                disabledDate={date => date && (date < moment(limitDates[0]) || date > moment(limitDates[1]))}
                fullWidth
                format="DD/MM/YYYY" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="endDate"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "endDate",
                  section: indicatorType,
                  entityId: edit?.id,
                  entity: "indicator"
                }}>
                  Fecha fin *
                </FieldLabel>
              }
              getValueFromEvent={getSelectValue}>
              <DateField
                id="endDate"
                disabled={ isBlocking}
                disabledDate={date => date && (date < moment(limitDates[0]) || date > moment(limitDates[1]))}
                fullWidth
                format="DD/MM/YYYY" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="measurementPeriodicity"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "measurementPeriodicity",
                  section: indicatorType,
                  entityId: edit?.id,
                  entity: "indicator"
                }}>
                  Periodicidad de medición
                </FieldLabel>
              }
              getValueFromEvent={getSelectValue}>
              <SelectField
                disabled={ isBlocking}
                id="measurementPeriodicity"
                options={measurementPeriodicityTypes} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="products"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "products",
                  section: indicatorType,
                  entityId: edit?.id,
                  entity: "indicator"
                }}>
                  Productos
                </FieldLabel>
              }>
              <MultipleTextField
                isAddDisabled={review ||  isBlocking}
                review={review ||  isBlocking}
                addLabel="Agregar producto" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
